import { Box, styled } from '@mui/material';
import { FIXED_FOOTER_HEIGHT, SIDE_NAV_WIDTH } from 'src/constants';

export const FooterContainer = styled(Box)(
  ({ theme }) => `
    z-index: 100;
    position: fixed;
    bottom: 0;
    left: ${SIDE_NAV_WIDTH}px;
    height: ${FIXED_FOOTER_HEIGHT}px;
    border-top: 1px solid ${theme.palette.secondary.lightest};
    width: calc(100% - ${SIDE_NAV_WIDTH}px);
    padding: 12px;
    background-color: #ffffff;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    `,
);
